import { TABLE_DIRECTION_ASC, TABLE_DIRECTION_DESC } from 'lib/tableLib'
import { useCallback, useState } from 'react'

function useSort(column, direction = TABLE_DIRECTION_ASC) {
  const [order, setOrder] = useState({ column, direction: direction })

  const setSort = useCallback((value) => {
    setOrder((s) => ({
      ...s,
      column: value,
      direction:
        s.column !== value || s.direction !== TABLE_DIRECTION_ASC
          ? TABLE_DIRECTION_ASC
          : TABLE_DIRECTION_DESC,
    }))
  }, [])

  return {
    order,
    setSort,
  }
}

export default useSort
